import { AmplitudeEventConstants } from '@homebot/shared-util-quartermaster'
import {
  LISTING,
  ADD_HOME,
  MARKET_TAB,
  SOLO_BUYER,
  BUYER,
  FAVORITE,
  HOMES,
  MARKETS,
  SAVED,
  SEARCH,
} from '../constants/navigation'
import {
  BuyerNavigationComponents,
  BuyerNavigationLinksMappedToAmplitude,
  HomeownerNavigationComponents,
} from '../types/navigation'
import { NEW_HOME, RENTAL_PROPERTY, RENT_BUY } from '../constants/gems.js'

export const TAB_NAMES = {
  ADD_HOME,
  BUYER,
  FAVORITE,
  HOMES,
  MARKETS,
  SAVED,
  SEARCH,
  LISTING,
}

export const YOUR_HOME_TAB_GROUPING = [TAB_NAMES.HOMES, TAB_NAMES.ADD_HOME]
export const FIND_A_HOME_TAB_GROUPING = [
  TAB_NAMES.BUYER,
  TAB_NAMES.MARKETS,
  TAB_NAMES.SEARCH,
  TAB_NAMES.FAVORITE,
  TAB_NAMES.SAVED,
  TAB_NAMES.LISTING,
]
export const FROM = {
  NEW_HOME,
  RENTAL_PROPERTY,
  RENT_BUY,
  MARKET_TAB,
  SOLO_BUYER,
}
export const EXPLORE_MARKET_TABS = {
  POPULAR_MARKETS: 'score',
  BIGGER_HOUSE: 'sqft',
  CHEAPER_BUYS: 'price',
  FASTEST_MOVE: 'timeline',
}

export const buyerLinksMappedToAmplitude: BuyerNavigationLinksMappedToAmplitude =
  {
    [BuyerNavigationComponents.BUYING_REPORT]:
      AmplitudeEventConstants.BUYING_REPORT,
    [BuyerNavigationComponents.EXPLORE_MARKETS]:
      AmplitudeEventConstants.EXPLORE_MARKETS,
    [BuyerNavigationComponents.FAVORITE_LISTINGS]:
      AmplitudeEventConstants.FAVORITE_LISTINGS,
    [BuyerNavigationComponents.SAVED_SEARCHES]:
      AmplitudeEventConstants.SAVED_SEARCHES,
    [BuyerNavigationComponents.SEARCH_HOMES]:
      AmplitudeEventConstants.SEARCH_HOMES,
  }

export function mapActiveTabToActiveDropdownItem(
  activeTab: string,
  selectedHomeId: string
):
  | BuyerNavigationComponents
  | HomeownerNavigationComponents
  | undefined
  | string {
  if (!activeTab) return undefined

  switch (activeTab) {
    case TAB_NAMES.BUYER:
      return BuyerNavigationComponents.BUYING_REPORT
    case TAB_NAMES.HOMES:
      return selectedHomeId
    case TAB_NAMES.MARKETS:
      return BuyerNavigationComponents.EXPLORE_MARKETS
    case TAB_NAMES.ADD_HOME:
      return HomeownerNavigationComponents.ADD_A_HOME
    case TAB_NAMES.SEARCH:
      return BuyerNavigationComponents.SEARCH_HOMES
    case TAB_NAMES.FAVORITE:
      return BuyerNavigationComponents.FAVORITE_LISTINGS
    case TAB_NAMES.SAVED:
      return BuyerNavigationComponents.SAVED_SEARCHES
    case TAB_NAMES.LISTING:
      return BuyerNavigationComponents.LISTING
    default:
      console.error('Invalid tab name')
      return undefined
  }
}
